import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Box, SkeletonText, Text } from '@chakra-ui/react';
import { isMobile } from 'src/component/CourseDetail/Practice/Util';
import CardLoader from 'src/component/CardLoader';

const InfiniteScrollWrapper = ({
    children,
    dataLength,
    fetchNextPage,
    hasNextPage,
}) => {
    let NoOfCards = isMobile ? 1 : 4;

    return (
        <InfiniteScroll
            style={{
                overflow: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
            }}
            dataLength={dataLength}
            next={fetchNextPage}
            hasMore={hasNextPage}
            loader={
                <Box>
                    <Box mb={4}>
                        <SkeletonText noOfLines={1} maxW="150px" borderRadius="md" />
                    </Box>
                    <Box display="flex" flexWrap="wrap" gap="16px">
                        {[...Array(NoOfCards)].map((_, i) => (
                            <CardLoader key={i} height="169px" maxW="500px" />
                        ))}
                    </Box>
                </Box>
            }
        >
            {children}
        </InfiniteScroll>
    );
};

export default InfiniteScrollWrapper;
